export const ScreenSizeConfiguration = {
  mobileScreen: 800,
  tabScreen: 950,
  tabviewStart: 801,
  tabviewEnd: 1024,
  desktopView: 1025,
};

export const IntervalConfiguration = {
  intervalTiny: 100,
  intervalExtraSmall: 200,
  intervalSmallMid: 350,
  intervalSmaller: 400,
  intervalSmall: 600,
  intervalMid: 460,
  intervalSemiMid: 700,
  intervalMedium: 1000,
  intervalLarge: 1500,
  intervalExtraLarge: 2000,
  intervalExtraLarger: 3000,
  intervalTicker: 7000,
  intervalPopup: 6000,
  intervalSpeedTicker: 50,
  intervalTimeout: 270,
};

export const RejectReasonLength = {
  lengthOfReason: 200,
  lengthOfDecline: 150,
};

export const errorcode = {
  errorNotFound: 404,
  errorFailed: 500,
  errorUnAuthorized: 401,
};

export const PaginationConfiguration = {
  paginationOptions: [50, 100],
  paginationSmall: 50,
  paginationBig: 100,
  paginationMid: 250,
  paginationExtraSmall: 102,
  currentPageText: "01",
  pageSize: 192,
};

export const GeoMapLeafletIcon = {
  /* customIcon */
  iconSize: [38, 38],
  iconAnchor: [19, 38],
  popupAnchor: [0, -38],
};

export const locationDefault = {
  officeLocation: [19.043690333072874, 72.8429991],
};

export const TimelineBarConfiguration = {
  extrasmallwidth: 0.25,
  smallwidth: 0.5,
  mediumwidth: 0.75,
  largewidth: 1,
};

export const GlobalConfiguration = {
  gstLength: 15,
  entityCardMinHeight: "110px",
  BeneAccCardMinHeight: "110px",
  BeneTxnCardMinHeight: "160px",
  OwnerCardMinHeight: "160px",
  inputValidationLength: 50,
  placeHolderAnimationLength: 80,
  fieldForceAccountountCardHoverHeight: 110,
  fieldForceAccountountListHoverHeight: 65,
  panLength: 10,
  ifscLength: 11,
  cinLength: 21,
  dinLength: 8,
  searchHeight: 10,
  accountminLength: 3,
  searchMaxOptionLength: 5,
  searchMinLength: 3,
  searchMaxLength: 50,
  accountnormalLength: 9,
  owneraccountnormalLength: 10,
  categoryminLength: 3,
  categorymaxLength: 20,
  lengthCheckZero: 0, //MENTIONED FOR THE ADD CATEGORY FLOW
  lengthCheckOne: 1, //MENTIONED FOR THE ADD CATEGORY FLOW
  lengthCheckNegativeOne: -1,
  lengthCheckTwo: 2,
  lengthCheckThree: 3,
  lengthCheckFour: 4,
  lengthCheckFive: 5,
  lengthCheckSix: 6,
  lengthCheckSeven: 7,
  dashboardPrimaryCount: "00",
  inputMaxLength: 150,
  filtered_search_min: "50px",
  filteredSearchHeight: 50,
  filter_search_height: "158px",
  navigate_back: -1,
  settleTypeValue: 200000,
  currentYear: 1975,
  innerWidthLargeSize: 3840,
  innerWidthMidSize: 2560,
  filterResults: 5,
  actionDelay: 3000,
  rtgs: 200000,
  otpCount: 60,
  otpLength: 6,
  delayTime: 1000,
  delayTimeMid: 4000,
  day_in_seconds: 86400,
  defaultAmount: 10000,
  autoCloseTime: 5000,
  rejectReasonMinLength: 10,

  // Card and List Hover Heights

  // Accounts
  beneAccountCardHoverHeight: 90,
  beneAccountListHoverHeight: 40,
  internalAccountCardHoverHeight: 90,
  internalAccountListHoverHeight: 40,
  ownerAccountCardHoverHeightWithoutRefresh: 160,
  ownerAccountCardHoverHeightWithRefresh: 210,
  ownerAccountListHoverHeightWithoutRefresh: 130,
  ownerAccountListHoverHeightWithRefresh: 180,
  reimbursementAccountCardHoverHeight: 90,
  reimbursementAccountListHoverHeight: 40,
  userHoverHeight: 40,

  // Transactions
  beneTxnCardHoverHeight: 280,
  beneTxnListHoverHeight: 90,
  internalTxnCardHoverHeight: 180,
  internalTxnListHoverHeight: 90,
  beneScheduleTxnCardHoverHeight: 110,
  reminderCardHoverHeight: 110,
  internalScheduleTxnCardHoverHeight: 60,
  reimbursementTxnCardHoverHeight: 140,
  reimbursementTxnListHoverHeight: 90,
  reimbursementRequestCardHoverHeightWithAmount: 110,
  reimbursementRequestCardHoverHeightWithoutAmount: 60,
  reimbursementRequestListHoverHeight: 60,
  privateTxnCardHoverHeightWithoutAmount: 160,
  privateTxnListHoverHeight: 63,

  // MultiApproval
  beneTxnMultiApprovalCardHoverHeight: 40,
  internalTxnMultiApprovalCardHoverHeight: 40,
  reimbursementTxnMultiApprovalCardHoverHeight: 40,
  ownerAccountConnectedBankingLength: 50,
};

export const CategoryFieldConfiguration = {
  fieldOptions: [
    { "Input field (alphanumeric)": "string" },
    { "Input field (numeric)": "numeric" },
    { "Single select dropdown": "list" },
    { "Multi select dropdown": "multi_select_list" },
    { "Day selector": "day" },
    { "Date selector": "date" },
    { "Month selector": "month" },
    { "Year selector": "year" },
    { "Month year selector": "month_year" },
    { "Date range selector": "date_range" },
    { "Year range selector": "from_year_to_year" },
    { Toggle: "toggle" },
    { "Upload file": "upload" },
    { "Set time": "time" },
    { Quantity: "quantity" },
    { "Enter URL": "hyperlink" },
  ],
};

export const SettingsStatisticsConfiguration = {
  translateHeight: 383,
  pieChartOuterRadius: 120,
  pieChartInnerRadius: 60,
  fillOpacityForLineGraph: 0.1,
  strokeWidthForLineGraph: 2,
  smallStrokeWidthForLineGraph: 1,
  radiusOfMarkForLineGraph: 6,
  zeroStrokeWidthForLineGraph: 0,
  paddingFromBothSide: 20,
};

export const TimelineConfiguration = {
  timeDuration: 100,
  totalSeconds: 1000,
  oneHour: 60,
  oneDay: 24,
  barwidthBase: 0.5,
  barWidthSmall: 1,
  barWidthMedium: 2,
  barWidthLarge: 3,
  actionBarWidth: 1.5,
};

export const PaymentMethodAnimationConfiguration = {
  slideDuration: 800,
};

export const TimePickerConfiguration = {
  hour: 12,
  minute: 60,
  meridiem: ["am", "pm"],
};

export const TopNavMenu = {
  menuItems: 2,
};

export const maxFileSize = 12 * 1024 * 1024;
